/**
 * VITRINE DE EMPREENDIMENTOS (VenturesShowcase) — conteúdo POR TENANT.
 *
 * Bloco editorial da home: foto grande com um cartão de texto por cima e CTA.
 * Diferente do `VenturesCarousel`/`home_ventures` (que vem do CRM via SSR), aqui
 * o conteúdo é CURADO — foto, chamada e texto são escolhidos a dedo pra vitrine,
 * não é a lista de empreendimentos publicados. Por isso mora em código, no mesmo
 * espírito das seções `_banner-<codsite>` da home.
 *
 * Só o tenant listado aqui renderiza a seção: `getVenturesShowcase` devolve null
 * para todos os outros — os ~300 sites seguem sem nenhuma mudança.
 */

export interface VentureShowcaseItem {
    /** Chamada do cartão (vai em caixa alta, com espaçamento de letra). */
    titulo: string;
    /** Texto descritivo do cartão. */
    texto: string;
    /** Foto de fundo do bloco (URL absoluta do CDN). */
    foto: string;
    /** Destino do bloco inteiro e do CTA (rota interna, sem o codsite). */
    href: string;
    /** Rótulo do CTA. Default: "Ver imóveis". */
    cta?: string;
}

const SHOWCASE_POR_TENANT: Record<number, VentureShowcaseItem[]> = {
    // cs2580 — Área Total Imóveis (Brasília). Os dois empreendimentos COMERCIAIS
    // da casa, que o cliente destacava no site anterior com este mesmo layout.
    // Os ids 537145/537146 são os cadastros em `tbl_empreendimento` do tenant.
    2580: [
        {
            titulo: 'Connect Towers',
            texto:
                'O Connect Towers é um prédio moderno com recepção ampla e controle de acesso biométrico, 9 elevadores, duas áreas verdes de convivência e estacionamento rotativo para 250 veículos. Auditório para 90 pessoas, salas de reunião, academia e lojas de conveniência.',
            foto: 'https://fotos2.fra1.cdn.digitaloceanspaces.com/foto_ce1.jpeg',
            href: '/empreendimento/537145',
        },
        {
            titulo: 'DF Plaza',
            texto:
                'O DF Plaza, em Brasília, faz parte de um complexo integrado que reúne residências, shopping, hipermercado e salas comerciais. Oferece salas a partir de 32 m², estacionamento próprio, serviços centralizados e elevadores inteligentes.',
            foto: 'https://fotos2.fra1.cdn.digitaloceanspaces.com/foto_ce2.jpeg',
            href: '/empreendimento/537146',
        },
    ],
};

/** Itens da vitrine do tenant, ou null quando ele não tem vitrine configurada. */
export const getVenturesShowcase = (codsite: any): VentureShowcaseItem[] | null => {
    const id = Number(codsite);
    if (!Number.isFinite(id) || id <= 0) return null;
    const itens = SHOWCASE_POR_TENANT[id];
    return itens && itens.length ? itens : null;
};
